import { useQuery } from '@tanstack/react-query'
import { useWatch } from 'react-hook-form'

import { dictionariesQueries } from '@/api/dictionaries/dictionariesQueries'
import AtomNotice from '@/components/Atoms/AtomNotice/AtomNotice'

import cn from '../ConfigModal.module.scss'
import {
  PriceBooleanSelectField,
  type PriceFieldContext,
  PriceSelectField,
  PriceTextField,
} from './PriceFields'

const PRICES_ENABLED_HINT =
  'Остатки склада будут продаваться только по ценам из файла, цены УТ для склада перестанут использоваться. После сохранения запустите загрузку: до неё у позиций склада не будет цены'

function PriceSettingsFields({ context }: { context: PriceFieldContext }) {
  const [enabled, currencyFromFile] = useWatch({
    control: context.control,
    name: ['enabled', 'currencyFromFile'],
  })
  const currenciesQuery = useQuery({
    ...dictionariesQueries.currencies(),
    enabled: enabled && !currencyFromFile,
  })
  const currencyOptions = (currenciesQuery.data ?? []).map((currency) => ({
    value: String(currency.code),
    label: `${currency.description} (${currency.code})`,
  }))

  return (
    <>
      <div className={cn.grid}>
        <PriceBooleanSelectField
          context={context}
          name="enabled"
          title="Загружать цены из файла"
          trueLabel="Да"
          falseLabel="Нет"
        />
      </div>
      {enabled && (
        <>
          <AtomNotice>{PRICES_ENABLED_HINT}</AtomNotice>
          <div className={cn.grid}>
            <PriceBooleanSelectField
              context={context}
              name="currencyFromFile"
              title="Грузить валюту из файла"
              trueLabel="Да"
              falseLabel="Нет"
            />
            {!currencyFromFile && (
              <PriceSelectField
                context={context}
                name="currencyFixedCode"
                title="Валюта"
                placeholder="Выберите валюту"
                options={currencyOptions}
                loading={currenciesQuery.isPending}
              />
            )}
            <PriceTextField
              context={context}
              name="purchaseExpectedHeader"
              title="Ожидаемый заголовок закупочной цены"
              placeholder="Например: Цена с НДС"
            />
            <PriceTextField
              context={context}
              name="rrcExpectedHeader"
              title="Ожидаемый заголовок РРЦ"
              placeholder="Необязательно"
            />
          </div>
        </>
      )}
    </>
  )
}

export default PriceSettingsFields
